import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LockSimple } from '@phosphor-icons/react';
import axios from 'axios';
import { useAdmin } from '../context/AdminContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminLoginPage = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAdmin();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      login(response.data.token);
      toast.success('Logged in successfully');
      navigate('/admin/products');
    } catch (error) {
      toast.error('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary/10 flex items-center justify-center mx-auto mb-4">
            <LockSimple size={32} className="text-primary" />
          </div>
          <h1 
            className="text-3xl uppercase tracking-tight font-bold"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            ADMIN ACCESS
          </h1>
          <p className="text-muted-foreground text-sm mt-2">
            Enter password to continue
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-12 bg-transparent border-border"
            data-testid="admin-password-input"
          />
          <Button
            type="submit"
            disabled={loading || !password}
            className="w-full h-12 bg-white text-black hover:bg-primary hover:text-white transition-colors font-bold uppercase tracking-wide"
            data-testid="admin-login-btn"
          >
            {loading ? 'LOGGING IN...' : 'LOGIN'}
          </Button>
        </form>
      </div>
    </div>
  );
};
